var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFriends(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n        .a{fill:#fff;}\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.035-15.75a4.383,4.383,0,0,1,2.672.949,2.538,2.538,0,0,1,1.266,1.863v2.813A6.911,6.911,0,0,1,3.551-7.91a4.125,4.125,0,0,1-1.23,1.9,1.049,1.049,0,0,0-.422,1,1.087,1.087,0,0,0,.633.9l4.887,2.32h.035a.624.624,0,0,1,.457.668V0H-7.84V-1.16a.677.677,0,0,1,.457-.633l4.957-2.355a1,1,0,0,0,.633-.861A1.161,1.161,0,0,0-2.18-6.047,4.107,4.107,0,0,1-3.445-7.928a6.515,6.515,0,0,1-.457-2.2v-2.812q0-.914,1.283-1.863A4.411,4.411,0,0,1,.035-15.75Zm3.445.141A5.518,5.518,0,0,0,.018-16.875a5.447,5.447,0,0,0-3.445,1.266,3.5,3.5,0,0,0-1.6,2.672v2.813A7.955,7.955,0,0,0-4.5-7.488a5.069,5.069,0,0,0,1.582,2.32L-7.84-2.812a1.2,1.2,0,0,0-.316.141,3.269,3.269,0,0,0-.492.4.832.832,0,0,0-.316.58V0a1.081,1.081,0,0,0,.334.791,1.081,1.081,0,0,0,.791.334H7.91A1.081,1.081,0,0,0,8.7.791,1.081,1.081,0,0,0,9.035,0V-1.687a.84.84,0,0,0-.281-.6,1.618,1.618,0,0,0-.562-.387L7.91-2.812,3.023-5.133a4.959,4.959,0,0,0,1.564-2.3,8.2,8.2,0,0,0,.51-2.689v-2.812A3.491,3.491,0,0,0,3.48-15.609Z",
    transform: "translate(8.965 16.875)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriends);
export default __webpack_public_path__ + "static/media/friends.054a9a1c5fb15d2c4ed97c1781ddcd08.svg";
export { ForwardRef as ReactComponent };